var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer hidden-xs-down"},[_c('p',[_vm._v("\n    Powered by "),_c('a',{attrs:{"href":_vm.companyURL,"target":"_blank"}},[_vm._v(_vm._s(_vm.company))]),_vm._v(" - ©"+_vm._s(_vm.getCurrentYear)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }